import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-privacy-dialog',
  templateUrl: './privacy-dialog.component.html',
  styleUrls: ['./privacy-dialog.component.scss']
})
export class PrivacyDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<PrivacyDialogComponent>) { }

  ngOnInit() {
    // this.dialogRef.updateSize('800px', '1200px');
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
